export enum MessageType {
  TEXT = "TEXT",
  IMAGE = "IMAGE",
  LOCATION = "LOCATION",
  SYSTEM = "SYSTEM",
}

export enum MessageDeliveryStatus {
  SENT = "SENT",
  DELIVERED = "DELIVERED",
  READ = "READ",
}

export enum ChatRoomStatus {
  ACTIVE = "ACTIVE",
  ENDED = "ENDED",
}
